import { useEffect, useRef } from "react";

import type { ChannelList } from "@/models/repositories/Feed.ts";

function feedPath(item: ChannelList, newDesign: boolean): string {
  if (newDesign && item.aliasMembershipId) {
    return `/workspaces/${item.workspaceId}/drivers/${item.aliasMembershipId}/channel/${item.id}`;
  }
  if (newDesign) {
    return `/workspaces/${item.workspaceId}/channels/${item.id}`;
  }
  return `/workspaces/${item.workspaceId}/feeds/${item.id}`;
}

export default function WebPipWindow({
  data,
  clickItem,
  newDesign,
}: {
  data: ChannelList[] | null | undefined;
  clickItem: (value: string) => void;
  newDesign: boolean;
}) {
  const pipWindowContainer = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = pipWindowContainer.current;
    if (!container) return;

    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const button = target.closest("button");
      if (button && button.classList.contains("pip-window-container-button")) {
        const value = button.getAttribute("value");
        if (value) {
          clickItem(value);
        }
      }
    };
    container.addEventListener("click", handleClick);
    return () => {
      container.removeEventListener("click", handleClick);
    };
  }, [data, clickItem, pipWindowContainer]);

  return (
    <div className="pip-window-container" ref={pipWindowContainer}>
      <>
        <div className={`pip-window-container-count ${data?.length > 0 ? "active" : ""}`}>
          You have {data?.length ?? 0} unread channels
        </div>
        <div className="pip-window-container-list">
          {data?.map((item) => (
            <button
              className="pip-window-container-button"
              key={`pip-item-${item.id}`}
              value={feedPath(item, newDesign)}
            >
              <span className="pip-item-title">{item.title}</span>
              <span className="red-dot" />
            </button>
          ))}
        </div>
      </>
    </div>
  );
}
